import React, { Suspense, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CssBaseline } from '@mui/material';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import Box from '@mui/material/Box';

import { getLocalizedTheme } from 'theme';
import Header from 'components/Header/Header';
import Sidebar from 'components/Sidebar/Sidebar';
import MainContent from 'components/MainContent';
// Loaded lazily: the scan flow pulls in the API client and the QR decoder, which the layout itself does not need.
const WorkCardScanFlow = React.lazy(() => import('features/ergani/workCard/WorkCardScanFlow'));

const Layout = () => {
  const { i18n } = useTranslation();
  const theme = useMemo(() => getLocalizedTheme(i18n.language), [i18n.language]);

  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexGrow: 1,
        minHeight: '100vh',
        overflowX: 'clip',
        backgroundColor: '#F3F5F7',
      }}
    >
      <EmotionThemeProvider theme={theme}>
        <CssBaseline />
        <Header />
        <Sidebar />
        <MainContent />
        {/* Work-card QR scanner, opened from the header button or the "Κάρτα Εργασίας" page */}
        <Suspense fallback={null}>
          <WorkCardScanFlow />
        </Suspense>
      </EmotionThemeProvider>
    </Box>
  );
};

export default Layout;
